// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"2917":"25bea90e25a3b115","4044":"1d750b850c2fb471","4515":"25bea90e25a3b115","4969":"b228183b565a77fb","5264":"aac231ca757949fd","8378":"e83dcc1aa4fe17b2"}[chunkId] + ".css";
};